import { useEffect, useState } from 'react';

import { Progress } from '@/components/ui/progress';
import { IDisclaimer } from '@/modules/case';

import { DisclaimerView } from './DisclaimerView';

interface DisclaimerOverlayProps {
  disclaimer: IDisclaimer;
  assetsBaseUrl: string;
  onComplete: () => void;
  duration?: number; // Duration in milliseconds
}

export const DisclaimerOverlay = ({
  disclaimer,
  assetsBaseUrl,
  onComplete,
  duration = 6000,
}: DisclaimerOverlayProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);

      if (newProgress >= 100) {
        clearInterval(interval);
        onComplete();
      }
    }, 50); // Update every 50ms for smooth animation

    return () => clearInterval(interval);
  }, [duration, onComplete]);

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col bg-background">
      {/* Main disclaimer content */}
      <div className="flex-1 overflow-hidden">
        <DisclaimerView disclaimer={disclaimer} assetsBaseUrl={assetsBaseUrl} />
      </div>

      {/* Progress bar positioned just above where navigation would be */}
      <div className="w-full px-4 pb-4">
        <Progress value={progress} className="h-2" />
      </div>
    </div>
  );
};
